/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/bonz/shared/constants.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'bonz/shared/constants', exports: {} }; const exports = module.exports;

const OmnitureEvents = Object.freeze({
    FORGOT_COMPLETE: 'FORGOT_PWD_COMPLETE',
    FORGOT_ERROR: 'FORGOT_PWD_ERROR',
    RESET_COMPLETE: 'RESET_PW_COMPLETE',
    RESET_ERROR: 'RESET_PW_ERROR',
    SIGNIN_COMPLETE: 'SIGN_IN_COMPLETE',
    SIGNIN_ERROR: 'SIGN_IN_ERROR',
    SIGNUP_COMPLETE: 'SIGN_UP_COMPLETE',
    SIGNUP_ERROR: 'SIGN_UP_ERROR',
})
export default {
    OmnitureEvents,
};